<div class="grid grid-cols-1 my-10">
    <mat-accordion class="max-w-4xl mt-8">
        <ng-container *ngFor="let seccionConfig of expediente.configuracionExpediente.seccionConfig">

            <mat-expansion-panel>
                <mat-expansion-panel-header [collapsedHeight]="'56px'">
                    <mat-panel-title class="font-medium leading-tight">{{seccionConfig.titulo}}</mat-panel-title>
                </mat-expansion-panel-header>
                <lib-informacion-general [expediente]="expediente" [sectionConfig]="seccionConfig" [readOnlyForm]="readOnlyForm">
                </lib-informacion-general>
            </mat-expansion-panel>
        </ng-container>
    </mat-accordion>
</div>
